var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-form"},[_c('v-text-field',{attrs:{"label":"Title","rules":[_vm.required],"autocomplete":"off"},model:{value:(_vm.item.title),callback:function ($$v) {_vm.$set(_vm.item, "title", $$v)},expression:"item.title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }